// extracted by css-extract-rspack-plugin
export default {"root":"v69d55","filled":"VoV1hX","outline":"druPvL"};